import { render } from "./InsightIndex.vue?vue&type=template&id=39811bb0"
import script from "./InsightIndex.vue?vue&type=script&lang=js"
export * from "./InsightIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__